import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getColorFilterConfig } from '../filters/color';
import { BuilderSections } from '../../util/builder';

const lipserviceSizes = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'XXXL',
  'S/M',
  'M/L',
  'L/XL',
  '24',
  '26',
  '27',
  '28',
  '30',
  '32',
  '34',
  '36',
  '38',
  'OS',
];

export const lipserviceShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: lipserviceSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.TopbarContent]: '83dc254c748a47788a8c56404d5f9a54',
      [BuilderSections.ListingCardDetails]: 'd41b0a2d7036483ea28d67dd0197b2d5',
      [BuilderSections.FooterContent]: '041fbcff1dbc44678929d2e042706c42',
    },
  },
};
